/* eslint-disable no-unused-vars */
import React, { useMemo } from "react";
import { Heading } from "@cars24/turbo-web/lib/heading";
import { Label } from "@cars24/turbo-web/lib/label";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { IconButton } from "@cars24/turbo-web/lib/icon-button";
import { Button } from "@cars24/turbo-web/lib/button";
import sparkleIcon from "./images/sparkle-icon.svg";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { SF_CMS_IMAGE_SLUGS } from "../../../constants/sf-landing-constants";
import ArrowIcon from "../../shared/arrow";
import { NUMBER } from "../../../constants/app-constants";
import { Helmet } from "react-helmet-async";

const SFLandingBanner = ({
    content = {},
    images = [],
    isBtnLoading,
    scrollToRef,
    onLoanTypeSelect,
    onApply
}) => {
    const { tokens } = useTokens();

    const handleLoanBtnClick = (index) => {
        onLoanTypeSelect(index);

        if (scrollToRef.current) {
            scrollToRef.current.scrollIntoView({ behavior: "smooth" });
        }
    };

    const { loanTypes = [], cta = "", heading = "" } = content || {};

    const bannerHeroImg = useMemo(
        () =>
      images?.filter(
          (image) => image?.imageSlug === SF_CMS_IMAGE_SLUGS.BANNER_HERO
      )?.[0] || {},
        [images]
    );

    return (
        <>
            <Helmet>
                <link
                    rel="preload"
                    as={"image"}
                    href={bannerHeroImg?.desktopImage}
                    type="image/webp"
                    fetchpriority="high"
                    media="(min-width: 1440px)"
                />
            </Helmet>
            <div styleName={"styles.sfLandingBanner"}>
                <div styleName={"styles.container"}>
                    <div styleName={"styles.sfLandingBannerContent"}>
                        <div styleName={"styles.sfLandingBannerContentLeft"}>
                            <Heading
                                isBold
                                level={NUMBER.ONE}
                                color={tokens.text_default_text_primary}
                            >
                                {heading || ""}
                            </Heading>
                            <img
                                src={sparkleIcon}
                                alt="sparkle"
                                styleName={"styles.sparkleIcon"}
                            />
                            <div styleName={"styles.loanTypesContainer"}>
                                <div styleName={"styles.loanType"}>
                                    <Label
                                        level={NUMBER.TWO}
                                        fontWeight="semibold"
                                        color={tokens.text_default_text_primary}
                                    >
                                        {loanTypes[0]?.title || ""}
                                    </Label>
                                    <div styleName={"styles.loanDescription"}>
                                        <Label
                                            level={NUMBER.THREE}
                                            fontWeight="regular"
                                            color={tokens.text_default_text_primary}
                                        >
                                            {loanTypes[0]?.description || ""}
                                        </Label>
                                    </div>
                                    <IconButton
                                        variant="background"
                                        onClick={() => handleLoanBtnClick(0)}
                                    >
                                        <ArrowIcon />
                                    </IconButton>
                                </div>
                                <div styleName={"styles.divider"} />
                                <div styleName={"styles.loanType"}>
                                    <Label
                                        level={NUMBER.TWO}
                                        fontWeight="semibold"
                                        color={tokens.text_default_text_primary}
                                    >
                                        {loanTypes[1]?.title || ""}
                                    </Label>
                                    <div styleName={"styles.loanDescription"}>
                                        <Label
                                            level={NUMBER.THREE}
                                            fontWeight="regular"
                                            color={tokens.text_default_text_primary}
                                        >
                                            {loanTypes[1]?.description || ""}
                                        </Label>
                                    </div>
                                    <IconButton
                                        variant="background"
                                        onClick={() => handleLoanBtnClick(1)}
                                    >
                                        <ArrowIcon />
                                    </IconButton>
                                </div>
                            </div>
                            <Button
                                label={cta}
                                size="large"
                                onClick={onApply}
                                loading={isBtnLoading}
                            />
                        </div>
                        <img
                            src={bannerHeroImg?.desktopImage}
                            alt="Tailored loans"
                            fetchpriority="high"
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

SFLandingBanner.propTypes = {
    onLoanTypeSelect: PropTypes.func,
    content: PropTypes.object,
    images: PropTypes.array,
    scrollToRef: PropTypes.object,
    onApply: PropTypes.func,
    isBtnLoading: PropTypes.bool
};

export default SFLandingBanner;
